export default {
  isEmpty: (state) => !state.items.length,
  allRead: (state) => state.items.every((item) => {
    return item.IsRead === 1 || item.IsRead === '1'
  })
}
